// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "AdviceSet" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { QuestionResponseGenShape } from "./question-response.gen";

export const AdviceSetGenShape = z.strictObject({
  name: z.string(),
  description: z.string(),
  slug: z.string(),
  snippetIds: z.array(z.string()),
  relatedAdvice: z.array(QuestionResponseGenShape),
  tagId: z.string().nullable().default(null),
  keywords: z.string().optional(),
  alwaysInclude: z.boolean().optional(),
  quickExit: z.boolean().optional(),
  libraryId: z.string(),
  created: z.string().optional(),
  createdUserId: z.string().optional(),
  lastEdited: z.string().optional(),
  lastEditedUserId: z.string().optional(),
  id: z.string(),
});
